import { LogLevel, BrowserCacheLocation, PublicClientApplication, IPublicClientApplication, InteractionType } from '@azure/msal-browser';
import {
  MsalInterceptorConfiguration,
  MsalGuardConfiguration,
  MsalInterceptor,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { getEnvironment } from 'src/environments/dinamicEnv';

const environment = getEnvironment();

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

const tenant = environment.azureTenant;

export const graphEndpoint = 'https://graph.microsoft.com/v1.0/me/';
export const { azureScopes } = environment;
export const authority = `https://login.microsoftonline.com/${tenant}`;

export function loggerCallback(logLevel: LogLevel, message: string) {
  if ('disableAzureLogin' in environment) {
    // eslint-disable-next-line dot-notation
    if (environment['disableAzureLogin']) {
      return;
    }
  }
  const event = message.slice(message.indexOf('msal:')).split('msal:')[1];

}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.azureClientId, // PPE testing environment
      authority,
      redirectUri: environment.appUri,
      postLogoutRedirectUri: environment.appUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      allowRedirectInIframe: false,
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(graphEndpoint, ['user.read']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: azureScopes
    },
    loginFailedRoute: environment.appUri,
  };
}

export const MSALProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true,
  },
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory,
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALGuardConfigFactory,
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: MSALInterceptorConfigFactory,
  },
  MsalService,
  MsalGuard,
  MsalBroadcastService,
];
